import { ComboSectionType } from "../types/option";

export const makeSection = (
  id: number,
  requiredSelections: number,
  productIds: number[] = [101, 102],
  allowDuplicateSelections = false,
): ComboSectionType => ({
  id,
  name: `Section ${id}`,
  requiredSelections,
  allowDuplicateSelections,
  isUpselling: false,
  products: productIds.map((pid) => ({
    id: pid,
    calories: 0,
    description: "",
    filterCategories: [],
    filterOrder: 0,
    imageUrl: "",
    name: `Item ${pid}`,
    nutritionalInformation: [],
    options: null,
    price: 5,
    variations: [],
    schedule: [],
    allergenInformation: {
      egg: "",
      fish: "",
      milk: "",
      mustard: "",
      sesame: "",
      crustaceans: "",
      soy: "",
      gluten: "",
    },
    countryCode: "SA" as const,
  })),
});
